import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import AssignmentIndOutlined from '@mui/icons-material/AssignmentIndOutlined';
import BrushOutlined from '@mui/icons-material/BrushOutlined';
import CableOutlined from '@mui/icons-material/CableOutlined';
import CorporateFareOutlined from '@mui/icons-material/CorporateFareOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import FeedbackOutlined from '@mui/icons-material/FeedbackOutlined';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import GavelOutlined from '@mui/icons-material/GavelOutlined';
import GppGoodOutlined from '@mui/icons-material/GppGoodOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import MailOutlined from '@mui/icons-material/MailOutlined';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import PaletteOutlined from '@mui/icons-material/PaletteOutlined';
import PasswordOutlined from '@mui/icons-material/PasswordOutlined';
import PersonAddOutlined from '@mui/icons-material/PersonAddOutlined';
import PolicyOutlined from '@mui/icons-material/PolicyOutlined';
import RouteOutlined from '@mui/icons-material/RouteOutlined';
import RuleOutlined from '@mui/icons-material/RuleOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import ShieldOutlined from '@mui/icons-material/ShieldOutlined';
import SummarizeOutlined from '@mui/icons-material/SummarizeOutlined';
import SupervisorAccountOutlined from '@mui/icons-material/SupervisorAccountOutlined';
import TableChartOutlined from '@mui/icons-material/TableChartOutlined';
import TravelExploreOutlined from '@mui/icons-material/TravelExploreOutlined';
import TuneOutlined from '@mui/icons-material/TuneOutlined';
import VpnKeyOutlined from '@mui/icons-material/VpnKeyOutlined';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

export const PERSONAL_ICONS: Record<
  number,
  OverridableComponent<SvgIconTypeMap>
> = {
  0: PaletteOutlined,
  1: NotificationsOutlined,
  2: VpnKeyOutlined,
  3: LockOutlined,
  4: PasswordOutlined,
  5: ShieldOutlined, // My Permissions
  6: SchoolOutlined, // RAI Training
};

export const ORG_ICONS: Record<number, OverridableComponent<SvgIconTypeMap>> = {
  0: GroupOutlined, // Members
  1: MailOutlined, // Invitations
  2: AssignmentIndOutlined, // Project Roles
  3: FolderOutlined, // Projects
  4: AccountTreeOutlined, // Organization Structure
  5: ShieldOutlined, // Security
  6: BrushOutlined, // Branding
  7: PolicyOutlined, // Policies
  8: DescriptionOutlined, // Report
  9: RuleOutlined, // Upload Rules
  10: CableOutlined, // Connections
  11: TravelExploreOutlined, // Model Discovery
  12: HistoryOutlined, // Activity Log
  13: Inventory2Outlined, // Audit Packages
};

export const SYS_ICONS: Record<number, OverridableComponent<SvgIconTypeMap>> = {
  0: CorporateFareOutlined,
  1: SupervisorAccountOutlined,
  2: GavelOutlined,
  3: SummarizeOutlined,
  4: TuneOutlined,
  5: RouteOutlined,
  6: HistoryOutlined,
  7: TableChartOutlined,
  8: Inventory2Outlined, // System Audit Packages
  9: FeedbackOutlined,
};
